import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
import { EquipmentOptions } from '@/modules/equipments/domain/equipment-options';
import { EquipmentsResult } from '@/modules/equipments/domain/equipments.result';
import { EquipmentRequest } from '@/modules/equipments/domain/equipment-request';
import { Parameter } from '@/modules/equipments/domain/parameter';

class EquipmentsRepository extends HttpRepository {
    private static readonly RESOURCE = 'equipments';

    /**
     * Obtiene los equipos registrados según los filtros establecidos
     * @Param equipmentsOptions: filtros establecidos
     * */
    async getEquipments(equipmentsOptions: EquipmentOptions): Promise<EquipmentsResult> {
        let dataCenterOption: string = equipmentsOptions.dataCenter
            ? `&dataCenterId=${equipmentsOptions.dataCenter}`
            : '';
        let buildingOption: string = equipmentsOptions.building
            ? `&buildingId=${equipmentsOptions.building}`
            : '';
        let keywordOption: string = equipmentsOptions.keyword
            ? `&keyword=${equipmentsOptions.keyword}`
            : '';

        return (
            await this.get(
                `${EquipmentsRepository.RESOURCE}?limit=${equipmentsOptions.limit}&start=${equipmentsOptions.start}${dataCenterOption}${buildingOption}${keywordOption}`,
                this.createAuthorizationHeader(),
            )
        ).data;
    }

    /**
     * Elimina un equipo de un lugar específico
     * @Param buildingEquipmentId: identificador del lugar y equipo.
     * */
    async deleteEquipment(buildingEquipmentId: number) {
        return await this.delete(
            `${EquipmentsRepository.RESOURCE}?buildingEquipmentId=${buildingEquipmentId}`,
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Crea un equipo
     * @Param equipment: datos del equipo a crear
     * */
    async createEquipment(equipment: EquipmentRequest) {
        return this.post(
            `${EquipmentsRepository.RESOURCE}`,
            equipment,
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Actualiza un equipo
     * @Param equipment: datos del equipo a actualizar
     * */
    async updateEquipment(equipment: EquipmentRequest) {
        return this.patch(
            `${EquipmentsRepository.RESOURCE}`,
            equipment,
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Obtiene los parámetros de los equipos
     * */
    async getParameters(): Promise<Parameter[]> {
        return (
            await this.get(
                `${EquipmentsRepository.RESOURCE}/parameters`,
                this.createAuthorizationHeader(),
            )
        ).data;
    }
}

export default new EquipmentsRepository();
